import axiosClient from "@/lib/axiosClient"
import type { Page, TargetListFilters, TargetListItem } from "@/types"

export const TARGETS_ENDPOINT = "/targets/"

export const buildTargetsParams = (
  filters: TargetListFilters,
): URLSearchParams => {
  const params = new URLSearchParams()

  params.append("page", filters.page.toString())
  params.append("size", filters.size.toString())

  if (filters.order_by) params.append("order_by", filters.order_by)
  if (filters.name) params.append("name", filters.name)
  if (filters.status) params.append("status", filters.status)
  if (typeof filters.is_template === "boolean") {
    params.append("is_template", String(filters.is_template))
  }
  if (typeof filters.is_fake === "boolean") {
    params.append("is_fake", String(filters.is_fake))
  }
  if (filters.created_by) params.append("created_by", filters.created_by)
  if (filters.date_from) params.append("date_from", filters.date_from)
  if (filters.date_to) params.append("date_to", filters.date_to)

  return params
}

export const getTargets = async (
  filters: TargetListFilters,
): Promise<Page<TargetListItem>> => {
  const params = buildTargetsParams(filters)
  const res = await axiosClient.get<Page<TargetListItem>>(
    `${TARGETS_ENDPOINT}?${params.toString()}`,
  )
  return res.data
}

export async function deleteTargetById(id: string): Promise<void> {
  await axiosClient.delete(`${TARGETS_ENDPOINT}${id}`)
}

/** Raw joined target (includes worked_stations / params.worked_units). */
export async function getTargetById(
  id: string,
): Promise<TargetListItem | null> {
  const res = await axiosClient.get<TargetListItem>(`${TARGETS_ENDPOINT}${id}`)
  return res.data ?? null
}
